export function getConsolidatedStatusBadgeClass(status?: string | null) {
  switch (status) {
    case "active":
      return "border-emerald-200 bg-emerald-50 text-emerald-700";
    case "inactive":
      return "border-rose-200 bg-rose-50 text-rose-700";
    default:
      return "border-slate-200 bg-slate-100 text-slate-700";
  }
}

export function getPendingStatusBadgeClass(label?: string | null) {
  const normalized = String(label ?? "").trim().toLowerCase();

  if (!normalized) {
    return "border-slate-200 bg-slate-100 text-slate-700";
  }

  const isInactiveFlow = normalized.includes("inativ");
  const isActiveFlow = normalized.includes("ativ");
  const isError = normalized.includes("erro");

  if (isInactiveFlow) {
    return isError
      ? "border-rose-300 bg-rose-100 text-rose-800"
      : "border-rose-200 bg-rose-50 text-rose-700";
  }

  if (isActiveFlow) {
    return isError
      ? "border-emerald-300 bg-emerald-100 text-emerald-800"
      : "border-emerald-200 bg-emerald-50 text-emerald-700";
  }

  return isError
    ? "border-amber-300 bg-amber-100 text-amber-800"
    : "border-slate-200 bg-slate-100 text-slate-700";
}
